__turbopack_context__.v({
  "boxshadow--none": "r29bbG_boxshadow--none",
  "centered": "r29bbG_centered",
  "colorScheme--alert": "r29bbG_colorScheme--alert",
  "colorScheme--archidekt": "r29bbG_colorScheme--archidekt",
  "colorScheme--bg": "r29bbG_colorScheme--bg",
  "colorScheme--cardhoarder": "r29bbG_colorScheme--cardhoarder",
  "colorScheme--cardkingdom": "r29bbG_colorScheme--cardkingdom",
  "colorScheme--cardsphere": "r29bbG_colorScheme--cardsphere",
  "colorScheme--commanderspellbook": "r29bbG_colorScheme--commanderspellbook",
  "colorScheme--content": "r29bbG_colorScheme--content",
  "colorScheme--dark": "r29bbG_colorScheme--dark",
  "colorScheme--light": "r29bbG_colorScheme--light",
  "colorScheme--manapool": "r29bbG_colorScheme--manapool",
  "colorScheme--muted": "r29bbG_colorScheme--muted",
  "colorScheme--patreon": "r29bbG_colorScheme--patreon",
  "colorScheme--scg": "r29bbG_colorScheme--scg",
  "colorScheme--selected": "r29bbG_colorScheme--selected",
  "colorScheme--subtle": "r29bbG_colorScheme--subtle",
  "colorScheme--success": "r29bbG_colorScheme--success",
  "colorScheme--surface": "r29bbG_colorScheme--surface",
  "colorScheme--tcgplayer": "r29bbG_colorScheme--tcgplayer",
  "colorScheme--warning": "r29bbG_colorScheme--warning",
  "container": "r29bbG_container",
  "disabled": "r29bbG_disabled",
  "fontNormal": "r29bbG_fontNormal",
  "hover--none": "r29bbG_hover--none",
  "iconLoading": "r29bbG_iconLoading",
  "justifyContent--center": "r29bbG_justifyContent--center",
  "justifyContent--left": "r29bbG_justifyContent--left",
  "justifyContent--right": "r29bbG_justifyContent--right",
  "label": "r29bbG_label",
  "loading": "r29bbG_loading",
  "maxwidth": "r29bbG_maxwidth",
  "padding--none": "r29bbG_padding--none",
  "size--lg": "r29bbG_size--lg",
  "size--sm": "r29bbG_size--sm",
  "size--xs": "r29bbG_size--xs",
  "variant--cardFiltersButton": "r29bbG_variant--cardFiltersButton",
  "variant--outline": "r29bbG_variant--outline",
});
